import React from 'react';
import { getHikedPrice, getTransationCharges } from '../../../../utils/getAmountWithTransaction';

const GuidePriceSummary = ({ bookingData, transactionCharges, paymentType, resetOffers, setNavDetails }) => {
    const isReserved = bookingData.amountPaid?.isReserved;

    const people = Number(bookingData?.people || 1);

    const total = Number(bookingData?.amountPaid?.total || 0);

    const discount = Number(bookingData?.amountPaid?.discount || 0);

    const offerAmount = Number(bookingData?.offerAmo || 0);

    const { actual, reserve, reserveTotal, pricePerPerson } = bookingData.priceDetails;

    const convenienceFee = isReserved ? getTransationCharges(reserveTotal) : Number(transactionCharges || 0);
    const finalTotal = isReserved
        ? reserveTotal + (paymentType === 'UPI' ? 0 : convenienceFee)
        : total - offerAmount + (paymentType === 'UPI' ? 0 : convenienceFee);
    console.log(bookingData, 'bookingData');
    return (
        <div className='tripBookDataInput'>
            <div className='tripPriceCal'>
                <p className='tripBookPrice'>
                    {people} x ₹{isReserved ? reserve : getHikedPrice(pricePerPerson)}
                </p>

                <p className='tripBookPrice'>₹{isReserved ? reserveTotal : getHikedPrice(actual)}</p>
            </div>

            {!isReserved && discount > 0 && (
                <div className='tripBookOfferDiv'>
                    <p className='tripBookOfferText'>Discount</p>

                    <p className='tripBookOfferText'>- ₹{discount}</p>
                </div>
            )}

            {offerAmount > 0 && (
                <div className='tripBookOfferDiv'>
                    <p className='tripBookOfferText'>Offer</p>

                    <p className='tripBookOfferText'>- ₹{offerAmount}</p>
                </div>
            )}

            {!isReserved && (
                <div className='tripBookOfferDiv'>
                    <p className='tripBookOfferText'>Tax</p>

                    <p className='tripBookOfferText'>+ ₹{bookingData?.amountPaid?.tax || 0}</p>
                </div>
            )}

            <div className='tripBookOfferDiv'>
                <p className='tripBookOfferText'>Convenience Fee</p>

                <p className='tripBookOfferText'>+ ₹{convenienceFee}</p>
            </div>

            {paymentType === 'UPI' && (
                <div className='tripBookOfferDiv'>
                    <p className='tripBookOfferText'>UPI Offers</p>

                    <p className='tripBookOfferText'>- ₹{convenienceFee}</p>
                </div>
            )}

            <div className='tripBookTotalDiv'>
                <p className='tripBookTotalText'>Total:</p>

                <p className='tripBookTotalText'>₹{finalTotal}</p>
            </div>

            <span />

            <button
                type='button'
                className='reviewBoSumChangeBtn grayBtn'
                onClick={() => {
                    resetOffers();
                    setNavDetails(true);
                }}
            >
                Change Details
            </button>
        </div>
    );
};

export default GuidePriceSummary;
